<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
    <h2>Download useful event Analytics reports drom below: </h2>
      </v-col>
      <div class="row pa-2">
          <div class="col-lg-4 col-md-6 col-sm-12" >
                <v-card
                  outlined
                  class="pa-3"
                >
                <v-card-title>
                  <v-list-item-avatar
                  tile
                  size="50"
                  class="pa-1"
                  color="blue"
                >icon</v-list-item-avatar>
                </v-card-title>
                <v-card-subtitle>Event Summary Report</v-card-subtitle>
                <v-card-text>High-level summary metrics about your event,
                  including attendee information, ticket sales and survey scores.
                  Options include a general event summary, or a summary report of a partical area of your event like a stage, 
                  session or expo both.
                </v-card-text>
                <v-card-action class="ml-8"><v-btn
                  outlined
                  rounded
                  text
                  color="primary"
                >
                  Download
                </v-btn></v-card-action>
                </v-card>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12" >
                <v-card
                  outlined
                  class="pa-3"
                >
                <v-card-title>
                  <v-list-item-avatar
                  tile
                  size="50"
                  class="pa-1"
                  color="blue"
                >icon</v-list-item-avatar>
                </v-card-title>
                <v-card-subtitle>Event Summary Report</v-card-subtitle>
                <v-card-text>High-level summary metrics about your event,
                  including attendee information, ticket sales and survey scores.
                  Options include a general event summary, or a summary report of a partical area of your event like a stage, 
                  session or expo both.
                </v-card-text>
                <v-card-action class="ml-8"><v-btn
                  outlined
                  rounded
                  text
                  color="primary"
                >
                  Download
                </v-btn></v-card-action>
                </v-card>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12" >
                <v-card
                  outlined
                  class="pa-3"
                >
                <v-card-title>
                  <v-list-item-avatar
                  tile
                  size="50"
                  class="pa-1"
                  color="blue"
                >icon</v-list-item-avatar>
                </v-card-title>
                <v-card-subtitle>Event Summary Report</v-card-subtitle>
                <v-card-text>High-level summary metrics about your event,
                  including attendee information, ticket sales and survey scores.
                  Options include a general event summary, or a summary report of a partical area of your event like a stage, 
                  session or expo both.
                </v-card-text>
                <v-card-action class="ml-8"><v-btn
                  outlined
                  rounded
                  text
                  color="primary"
                >
                  Download
                </v-btn></v-card-action>
                </v-card>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12" >
                <v-card
                  outlined
                  class="pa-3"
                >
                <v-card-title>
                  <v-list-item-avatar
                  tile
                  size="50"
                  class="pa-1"
                  color="blue"
                >icon</v-list-item-avatar>
                </v-card-title>
                <v-card-subtitle>Event Summary Report</v-card-subtitle>
                <v-card-text>High-level summary metrics about your event,
                  including attendee information, ticket sales and survey scores.
                  Options include a general event summary, or a summary report of a partical area of your event like a stage, 
                  session or expo both.
                </v-card-text>
                <v-card-action class="ml-8"><v-btn
                  outlined
                  rounded
                  text
                  color="primary"
                >
                  Download
                </v-btn></v-card-action>
                </v-card>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12" >
                <v-card
                  outlined
                  class="pa-3"
                >
                <v-card-title>
                  <v-list-item-avatar
                  tile
                  size="50"
                  class="pa-1"
                  color="blue"
                >icon</v-list-item-avatar>
                </v-card-title>
                <v-card-subtitle>Event Summary Report</v-card-subtitle>
                <v-card-text>High-level summary metrics about your event,
                  including attendee information, ticket sales and survey scores.
                  Options include a general event summary, or a summary report of a partical area of your event like a stage, 
                  session or expo both.
                </v-card-text>
                <v-card-action class="ml-8"><v-btn
                  outlined
                  rounded
                  text
                  color="primary"
                >
                  Download
                </v-btn></v-card-action>
                </v-card>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12" >
                <v-card
                  outlined
                  class="pa-3"
                >
                <v-card-title>
                  <v-list-item-avatar
                  tile
                  size="50"
                  class="pa-1"
                  color="blue"
                >icon</v-list-item-avatar>
                </v-card-title>
                <v-card-subtitle>Event Summary Report</v-card-subtitle>
                <v-card-text>High-level summary metrics about your event,
                  including attendee information, ticket sales and survey scores.
                  Options include a general event summary, or a summary report of a partical area of your event like a stage, 
                  session or expo both.
                </v-card-text>
                <v-card-action class="ml-8"><v-btn
                  outlined
                  rounded
                  text
                  color="primary"
                >
                  Download
                </v-btn></v-card-action>
                </v-card>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12" >
                <v-card
                  outlined
                  class="pa-3"
                >
                <v-card-title>
                  <v-list-item-avatar
                  tile
                  size="50"
                  class="pa-1"
                  color="blue"
                >icon</v-list-item-avatar>
                </v-card-title>
                <v-card-subtitle>Event Summary Report</v-card-subtitle>
                <v-card-text>High-level summary metrics about your event,
                  including attendee information, ticket sales and survey scores.
                  Options include a general event summary, or a summary report of a partical area of your event like a stage, 
                  session or expo both.
                </v-card-text>
                <v-card-action class="ml-8"><v-btn
                  outlined
                  rounded
                  text
                  color="primary"
                >
                  Download
                </v-btn></v-card-action>
                </v-card>
          </div>
      </div>
    </v-row>
  </v-container>
</template>
<script>
export default {
    beforeRouteEnter (to, from, next) {
      const token = localStorage.getItem('token')
  if(token){
    next()
  }
  else
    next('/login')
  },
}
</script>